module.exports = __webpack_public_path__ + "static/img/2.ea36803.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/zh/2.png
// module id = DDVu
// module chunks = 0